
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collections-and-research/conservation",
      function () {
        return require("private-next-pages/collections-and-research/conservation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collections-and-research/conservation"])
      });
    }
  